/**
 * Adapter unificato: routing automatico tra Spotify e Deezer
 * basato su MUSIC_PROVIDER in src/config/musicProvider.js.
 *
 * Tutte le funzioni restituiscono lo stesso shape di dati (normalizzato Spotify),
 * quindi i componenti non devono sapere quale provider è attivo.
 */

import { MUSIC_PROVIDER } from '../config/musicProvider';
import { searchSpotifyArtist } from './spotify';
import SpotifyService from './spotify';
import { searchDeezerArtist, getDeezerArtistAlbums } from './deezer';

export { MUSIC_PROVIDER };

/**
 * Cerca un artista sul provider attivo.
 * Stessa firma di searchSpotifyArtist (spotifyId ignorato in modalità Deezer).
 * Restituisce oggetto normalizzato con: id, name, images[], external_urls, genres, albums[]
 */
export const searchArtistForProvider = (
    artistName,
    spotifyId = null,
    genreHint = null,
    originHint = null,
    skipAlbums = false
) => {
    if (MUSIC_PROVIDER === 'deezer') {
        return searchDeezerArtist(artistName, genreHint, originHint, skipAlbums);
    }
    return searchSpotifyArtist(artistName, spotifyId, genreHint, originHint, skipAlbums);
};

/**
 * Carica gli album di un artista.
 * artistId = Deezer ID in modalità Deezer, Spotify ID in modalità Spotify.
 * Restituisce { items: [...] } con album normalizzati.
 */
export const getArtistAlbumsForProvider = (artistId) => {
    if (MUSIC_PROVIDER === 'deezer') {
        return getDeezerArtistAlbums(artistId);
    }
    return SpotifyService.getArtistAlbums(artistId);
};
